<template>
    <transition-group tag="ul" name="slide-fade" class="users-list">
        <users-list-item v-for="user in users" 
            :user="user"
            :from="from"
            :admin="admin"
            @userAdded="addToGroup"
            @userRemoved="removeFromGroup"
            :key="user.userID || user.objectID">
        </users-list-item>
    </transition-group>
</template>

<script>
import UsersListItem from './UsersListItem.vue'

export default {
    props: {
        users: {
            type: Array
        },
        from: {
            type: String,
            required: false
        },
        admin: {
            type: String
        }
    },
    components: {
        UsersListItem
    },
    methods: {
        //FOR GROUPS
        addToGroup(user) {
            this.$emit('userAdded', user)
        },
        removeFromGroup(user) {
            this.$emit('userRemoved', user)
        }
    }
}
</script>

<style scoped>
    [v-cloak] {
        display: none;
    }

    .users-list {
        overflow: hidden;
    }
</style>




// WEBPACK FOOTER //
// src/components/users/userView/UsersList.vue